module.exports = __webpack_public_path__ + "img/pagebanner-rules.98e50fb7.jpg";